import React, { FC } from 'react';
import styled, { useTheme } from 'styled-components';
import { KitFlexRowCentered } from '../KitFlexbox';
import KitButton from '../KitButton';
import KitIcon from '../KitIcon';
import { KitIconCounterButtonProps, COUNTER_LIMIT } from './interfaces';
import { KitLabelText, KitCounter } from './styles';
import ThemeSchema from '../../common/theme/schema';
import { iconSize } from '../../common/theme/constants';

const StyledButton = styled(KitButton)<{ showLabel: boolean }>`
  background-color: ${({ theme }) => theme.page.body.bg} !important;
  padding: 6px ${({ showLabel }) => (showLabel ? '12px' : '6px')};
  min-width: ${({ showLabel }) => (showLabel ? '96px' : 'unset')};
`;

const KitIconCounterButton: FC<KitIconCounterButtonProps> = ({
  className,
  onClick,
  counter = 0,
  showLabel,
  labelText,
  icon,
  iconColor,
  ...rest
}) => {
  const theme = useTheme() as ThemeSchema;

  return (
    <StyledButton
      onClick={onClick}
      variant='link'
      className={className}
      aria-label={labelText}
      showLabel={showLabel}
      {...rest}
    >
      <KitFlexRowCentered>
        <KitIcon icon={icon} size={`${iconSize.s}rem`} fill={iconColor || theme.icon} />
        {showLabel && <KitLabelText>{labelText}</KitLabelText>}
        {!!counter && (
          <KitCounter>{counter <= COUNTER_LIMIT ? counter : `${COUNTER_LIMIT}+`}</KitCounter>
        )}
      </KitFlexRowCentered>
    </StyledButton>
  );
};

export default KitIconCounterButton;
